/// Persists the opaque session token, mirroring
/// mobile/lib/auth/data/session_token_store.dart.
///
/// The token lives in localStorage rather than an httpOnly cookie: the backend
/// authenticates bearer tokens only, exactly as the Flutter client does, so no
/// server-side auth change is needed. The trade-off is that XSS could read it.

const sessionTokenKey = 'sessionToken';

export function readSessionToken(): string | null {
  try {
    return localStorage.getItem(sessionTokenKey);
  } catch {
    return null;
  }
}

export function writeSessionToken(token: string): void {
  try {
    localStorage.setItem(sessionTokenKey, token);
  } catch {
    // Non-fatal: the session just will not survive a reload.
  }
}

export function clearSessionToken(): void {
  try {
    localStorage.removeItem(sessionTokenKey);
  } catch {
    // Ignored for the same reason as above.
  }
}
